<label
	class="component-field-input-checkbox show"
	[class.check-touched]="isTouched"
	[class.check-error]="hasError"
	[class.check-valid]="isValid"
	(mouseenter)="mouseenter()"
	(mouseleave)="mouseleave()"
>
	<section class="check-section-body">
		<div class="check-icon">
			@if (isRequired) {
				<lbca-icon
					[class.check-filled]="hasValue"
					class="check-light"
					size="small"
					name="lucide:asterisk"
				/>
			}
			<p class="check-label">{{ labelValue }}</p>
		</div>
		<div>
			@for (option of options; track option) {
				<label
					class="check-template show"
					[class.flex]="!inlineFields"
					[class.inline-flex]="inlineFields"
					[class.disabled]="isDisabled"
				>
					<input
						type="checkbox"
						class="check-field"
						[disabled]="isDisabled"
						name="{{ labelValue }}"
						[checked]="valueSelected.indexOf(option.id) > -1 ? 'checked' : ''"
						(click)="selectOption($event, option)"
					/>
					<span class="overflow-control-indicator"></span>
					<span class="chk-text">{{ option.label }}</span>
				</label>
			}
		</div>

		<div class="check-focus-marker">&nbsp;</div>
	</section>
	<section class="check-section-icon">
		<div class="icon-box check-icon-validation"></div>
	</section>
</label>
